import { createStore } from 'redux';


const initialState = {
  username: '',
  broker:'',
  sidebarShow: JSON.parse(localStorage.getItem("sidebarShow")) ?? true,
  sidebarUnfoldable: JSON.parse(localStorage.getItem("sidebarUnfoldable")) ?? false,  
  // asideShow: false,
  theme: '',
};

const reducer = (state = initialState, action) => {
  console.log(action)
  switch (action.type) {
    case 'set':
      return {
        ...state,
        sidebarShow: action.sidebarShow !== undefined ? action.sidebarShow : state.sidebarShow,
        sidebarUnfoldable: action.sidebarUnfoldable !== undefined ? action.sidebarUnfoldable : state.sidebarUnfoldable,
      };
    case 'set2':
        return { ...state,
        sidebarShow: action.sidebarShow
        }
    case 'SET_BROKER':
        return {
          ...state,
          broker: action.payload, 
        };
    case 'SET_NAME':
      return {
        ...state,
        name: action.payload
      };
      case 'SET_SHOW_CHILD':
      return {
        ...state,
        showChild: action.payload
      };
    case 'SET_USERNAME':
      return {
        ...state,
        username: action.payload
      };
    case 'SET_SDATE':
      return {
        ...state,
        sdate: action.payload
      };
    case 'SET_EDATE':
      return {
        ...state,
        edate: action.payload
    };
    default:
      return state;
  }
};


const store = createStore(reducer);

export default store;
